import React, {Component} from 'react'
import {deleteUserGroup} from '../../../../actions/usergroups'
import store, {history} from '../../../../store'
import IgniteDataTable from '../../../common/datatable'
import ConfirmPopup from '../../../common/confirm-popup'

class UserGroupsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  render() {
    const columns = [
      {prop: 'name', title: 'Name'},
      {prop: 'num-of-users', title: 'Users'},
      {prop: 'num-of-permissions', title: 'Permissions'},
    ];

    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'update',
          subjectClass: 'UserGroup'
        },
        callback: (row) => {
          history.push(`/admin/user-groups/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'UserGroup'
        },
        disabled: (row) => {
          const numOfUsers = row.attributes['num-of-users'],
                groupName  = row.attributes.name;
          return numOfUsers > 0 || groupName === 'Super admin' || groupName === 'Owner' || groupName === 'Staff' || groupName === 'Account Manager';
        },
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    const handleDelete = (result) => {
      const id = this.state.delete.id;
      this.setState({delete: {show: false}});
      if (result) {
        store.dispatch(deleteUserGroup(id));
      }
    };

    return (
      <div>
        <IgniteDataTable
          data={this.props.userGroups}
          columns={columns}
          actions={actions}
        />

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE USER GROUP?"
                        onClose={handleDelete}>
            <p>Are you sure you want to delete the selected usergroup?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

export default UserGroupsList



// WEBPACK FOOTER //
// ./src/components/admin/usergroups/list/usergroups-list.jsx